module.exports = __webpack_public_path__ + "img/southeast-winter-544x667.8bd48274.jpg";